(function () {
  "use strict";
  function init() {
    var drawer = document.querySelector('[data-sk-drawer="cart"]');
    if (!drawer || drawer.querySelector('[data-isd-cart-recs]')) return;
    var prefs = (window.ISD && window.ISD.cartUi) || {};
    var mobileMedia = window.matchMedia("(max-width: 989px)");
    var cartBody = drawer.querySelector("[data-sk-cart-body]");
    var mobileAllowed = prefs.recsMobileEnabled !== false;
    var rail = document.createElement("aside");
    if(prefs.recsEnabled === false && prefs.recsMobileEnabled === false) { drawer.classList.add("isd-cart-recs-off"); return; }
    rail.style.setProperty("--isd-recs-background",prefs.recsBackground || "#F7F6F0");
    rail.className = "isd-cart-recs";
    rail.setAttribute("data-isd-cart-recs", "");
    rail.setAttribute("aria-label", "Produktų rekomendacijos");
    var eyebrow = document.createElement("p"); eyebrow.className="isd-cart-recs__eyebrow"; eyebrow.textContent=prefs.recsEyebrow || "ITALIŠKI SKONIAI";
    var title = document.createElement("h3"); title.className="isd-cart-recs__title"; title.textContent=prefs.recsTitle || "Papildykite krepšelį";
    var sub = document.createElement("p"); sub.className="isd-cart-recs__sub"; sub.textContent=prefs.recsSubtitle || "Keli skoniai, kurie gali papildyti Jūsų pasirinkimus.";
    var list = document.createElement("div"); list.className="isd-cart-recs__list"; list.setAttribute("aria-live","polite");
    var browse = document.createElement("a"); browse.href=prefs.recsUrl || "/collections/italiski-produktai"; browse.className="isd-cart-recs__browse"; browse.textContent=prefs.recsLinkText || "Atrasti visus produktus →";
    var error = document.createElement("p"); error.className="isd-cart-recs__error"; error.setAttribute("role","status");
    rail.append(eyebrow,title,sub,list,browse,error); drawer.append(rail);
    rail.dataset.isdMobileUpsellV2 = "1";
    var cache = {}, sequence=0, lastCart=null;
    function placeRail() {
      if (mobileMedia.matches) {
        var active = mobileAllowed && lastCart && lastCart.item_count > 0;
        rail.hidden = !active;
        title.textContent = prefs.recsMobileTitle || prefs.recsTitle || "Papildykite savo krepšelį";
        sub.hidden = prefs.recsMobileSubtitle !== true;
        if (active && cartBody && rail.parentNode !== cartBody) cartBody.appendChild(rail);
      } else {
        var desktopAllowed = prefs.recsEnabled !== false;
        rail.hidden = !desktopAllowed;
        drawer.classList.toggle("isd-cart-recs-off", !desktopAllowed);
        title.textContent = prefs.recsTitle || "Papildykite krepšelį";
        sub.hidden = false;
        if (desktopAllowed && rail.parentNode !== drawer) drawer.appendChild(rail);
      }
    }
    if (cartBody) {
      var bodyObserver = new MutationObserver(function(){
        if (mobileMedia.matches && lastCart && lastCart.item_count && mobileAllowed &&
            !cartBody.contains(rail)) {
          cartBody.appendChild(rail);
        }
      });
      bodyObserver.observe(cartBody,{childList:true});
    }
    if (typeof mobileMedia.addEventListener === "function") mobileMedia.addEventListener("change", function(){placeRail();if(lastCart)render(lastCart);});
    placeRail();
    var money = function(cents){ if(window.ISD&&typeof window.ISD.money==="function")return window.ISD.money(cents);return new Intl.NumberFormat("lt-LT",{style:"currency",currency:"EUR"}).format(Number(cents)/100); };
    function empty(message) {list.replaceChildren(); var p=document.createElement("div");p.className="isd-cart-recs__empty";p.textContent=message;list.appendChild(p);}
    function filter(products,cart) {
      var ids = new Set((cart.items||[]).map(function(i){return String(i.product_id);}));
      return (products||[]).filter(function(p){
        if(!p||!p.available||ids.has(String(p.id))||!p.handle)return false;
        var type=String(p.type||p.product_type||"").toLowerCase();
        if(type.includes("dėžut")||type.includes("dezut")||type.includes("priedas"))return false;
        return Array.isArray(p.variants)&&p.variants.some(function(v){return v.available;});
      }).slice(0,Math.max(2,Math.min(6,Number(prefs.recsCount)||4)));
    }
    function show(products) {
      list.replaceChildren();
      if(!products.length){empty("Išsirinkite dar ką nors skanaus iš mūsų itališkų produktų.");return;}
      products.forEach(function(p){
        var variant=p.variants.find(function(v){return v.available;});
        if(!variant)return;
        var card=document.createElement("article"); card.className="isd-cart-rec";
        var img=document.createElement("img");img.className="isd-cart-rec__image";img.alt="";img.loading="lazy";img.width=78;img.height=84;
        var src=p.featured_image&&typeof p.featured_image==="object"?p.featured_image.src:p.featured_image;
        if(!src&&p.images&&p.images.length)src=p.images[0].src||p.images[0];
        if(src)img.src=src;
        var info=document.createElement("div");
        var name=document.createElement("a");name.className="isd-cart-rec__name";name.href="/products/"+encodeURIComponent(p.handle);name.textContent=p.title;
        var price=document.createElement("strong");price.className="isd-cart-rec__price";price.textContent=money(variant.price);
        var btn=document.createElement("button");btn.type="button";btn.className="isd-cart-rec__add";btn.dataset.isdRecsAdd=String(variant.id);btn.textContent=prefs.recsAddLabel || "+ Įdėti į krepšelį";btn.setAttribute("aria-label","Įdėti į krepšelį: "+p.title);
        info.append(name,price,btn);card.append(img,info);list.append(card);
      });
    }
    function render(cart) {
      if(!cart)return;
      lastCart=cart;
      placeRail();
      var token=++sequence; error.textContent="";
      if(!cart.items||!cart.items.length){empty("Jūsų krepšelis tuščias. Atraskite itališkus skonius.");return;}
      if(mobileMedia.matches && !mobileAllowed)return;
      if(!mobileMedia.matches && prefs.recsEnabled === false)return;
      var first=cart.items.find(function(i){return !/dėžut|dezut/i.test(String(i.product_type||""));})||cart.items[0];
      var key=String(first.product_id);
      if(cache[key]){show(filter(cache[key],cart));return;}
      empty("Ieškome produktų, kurie derėtų su Jūsų pasirinkimais…");
      var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/"; if(root.slice(-1)!=="/")root+="/";
      fetch(root+"recommendations/products.json?product_id="+encodeURIComponent(key)+"&limit=10&intent=related",{credentials:"same-origin"})
        .then(function(resp){if(!resp.ok)throw Error("recommendations unavailable");return resp.json();})
        .then(function(data){
          var recommended = Array.isArray(data.products) ? data.products : [];
          if (filter(recommended,cart).length) return recommended;
          return fetch(root+"collections/italiski-produktai/products.json?limit=20",{credentials:"same-origin"})
            .then(function(resp){if(!resp.ok)throw Error("collection products unavailable");return resp.json();})
            .then(function(fallback){return Array.isArray(fallback.products)?fallback.products:[];})
            .catch(function(){return recommended;});
        })
        .then(function(products){cache[key]=products;if(token===sequence)show(filter(products,lastCart));})
        .catch(function(){if(token===sequence)empty("Atraskite daugiau itališkų produktų mūsų parduotuvėje.");});
    }
    rail.addEventListener("click",function(event){
      var btn=event.target.closest("button[data-isd-recs-add]");
      if(!btn||btn.disabled)return;
      if(!window.ISD||!window.ISD.cart||typeof window.ISD.cart.add!=="function")return;
      btn.disabled=true;btn.textContent="Pridedama…";error.textContent="";
      window.ISD.cart.add(Number(btn.dataset.isdRecsAdd),1).then(function(){btn.textContent="Pridėta ✓";})
        .catch(function(){btn.disabled=false;btn.textContent=prefs.recsAddLabel || "+ Įdėti į krepšelį";error.textContent="Nepavyko įdėti. Bandykite dar kartą.";});
    });
    document.addEventListener("isd:cart",function(e){if(e.detail&&e.detail.cart)render(e.detail.cart);});
    var mo=new MutationObserver(function(){if(drawer.classList.contains("is-open")&&window.ISD&&window.ISD.cart){window.ISD.cart.get().then(render).catch(function(){});}});
    mo.observe(drawer,{attributes:true,attributeFilter:["class"]});
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
})();


(function () {
  "use strict";
  function initCartTimer() {
    var drawer = document.querySelector('[data-sk-drawer="cart"]');
    if (!drawer || drawer.querySelector("[data-isd-cart-timer]")) return;
    var cfg = window.ISD && window.ISD.cartUi || {};
    if (cfg.timerEnabled === false) return;
    var header = drawer.querySelector('[class*="sk-hd__drawer-head-"]');
    if (!header) return;
    var duration = Math.max(1, Math.min(30, Number(cfg.timerMinutes) || 10)) * 60 * 1000;
    var storageKey = "isd-shopping-reminder-deadline-v1";
    var deadline = 0;
    var tickId = null;
    var finishedKey = "isd-shopping-reminder-ended-v1";
    var finished = false;
    var view = document.createElement("div");
    view.className = "isd-cart-timer";
    view.setAttribute("data-isd-cart-timer","");
    view.hidden = true;
    view.style.setProperty("--isd-timer-bg", cfg.timerBg || "#171717");
    view.style.setProperty("--isd-timer-fg", cfg.timerFg || "#FFFFFF");
    view.style.setProperty("--isd-timer-pad",Math.max(8,Math.min(24,Number(cfg.timerPadding)||16))+"px");
    var label = document.createElement("span");
    label.className = "isd-cart-timer__label";
    label.textContent = cfg.timerLabel || "APSIPIRKIMO LAIKMATIS";
    var clock = document.createElement("strong");
    clock.className = "isd-cart-timer__clock";
    clock.setAttribute("role","timer");
    clock.setAttribute("aria-label","Likęs apsipirkimo laikmačio laikas");
    clock.textContent = "10:00";
    view.append(label,clock);
    header.appendChild(view);
    try { deadline = Number(window.sessionStorage.getItem(storageKey)) || 0; finished = window.sessionStorage.getItem(finishedKey) === "1"; } catch(e) {}
    function stop() {if(tickId!==null){window.clearInterval(tickId);tickId=null;}}
    function reset() {
      deadline=0;finished=false;stop();view.hidden=true;
      try { window.sessionStorage.removeItem(storageKey); window.sessionStorage.removeItem(finishedKey); } catch(e) {}
    }
    function paint() {
      if(!deadline&&!finished){view.hidden=true;stop();return;}
      var remain=Math.max(0,deadline-Date.now());
      if(deadline&&remain<=0){deadline=0;finished=true;stop();try{window.sessionStorage.removeItem(storageKey);window.sessionStorage.setItem(finishedKey,"1");}catch(e){}}
      if(finished){clock.textContent="00:00";view.hidden=false;stop();return;}
      var total=Math.ceil(remain/1000);
      clock.textContent=String(Math.floor(total/60)).padStart(2,"0")+":"+String(total%60).padStart(2,"0");
      view.hidden=false;
    }
    function ensureTick(){paint();if(deadline>Date.now()&&tickId===null){tickId=window.setInterval(paint,1000);}}
    function handleCart(detail){
      if(!detail||!detail.cart)return;
      if(!detail.cart.item_count){reset();return;}
      if(detail.action==="add"&&!deadline){
        finished=false;deadline=Date.now()+duration;
        try{window.sessionStorage.setItem(storageKey,String(deadline));window.sessionStorage.removeItem(finishedKey);}catch(e){}
      } else if(!deadline&&!finished&&drawer.classList.contains("is-open")) {
        deadline=Date.now()+duration;
        try{window.sessionStorage.setItem(storageKey,String(deadline));}catch(e){}
      }
      if(deadline||finished)ensureTick();
    }
    document.addEventListener("isd:cart",function(e){handleCart(e.detail);});
    if(window.ISD&&window.ISD.cart){
      if(typeof window.ISD.cart.subscribe==="function"){
        window.ISD.cart.subscribe(function(cart,detail){
          if(detail&&detail.action==="replay")handleCart({cart:cart,action:"replay"});
        });
      }
      if(typeof window.ISD.cart.get==="function")window.ISD.cart.get().catch(function(){});
    }
    if(deadline||finished)ensureTick();
    document.addEventListener("visibilitychange",function(){if(!document.hidden&&(deadline||finished))ensureTick();});
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initCartTimer,{once:true});
  else initCartTimer();
})();
